import React, { useRef, useState } from 'react';
import AccHeroSection from '../../../components/landingPage/AcceleratorsPage/AccHeroSection';
import AccTabBar from '../../../components/landingPage/AcceleratorsPage/AccTabBar';
import AccMarketContextSection from '../../../components/landingPage/AcceleratorsPage/AccMarketContextSection';
import AccReverseDiligenceSection from '../../../components/landingPage/AcceleratorsPage/AccReverseDiligenceSection';
import AccOnePlatformSection from '../../../components/landingPage/AcceleratorsPage/AccOnePlatformSection';
import AccOperatorModulesSection from '../../../components/landingPage/AcceleratorsPage/AccOperatorModulesSection';
import AccFirstMoversSection from '../../../components/landingPage/AcceleratorsPage/AccFirstMoversSection';
import AccFlowsSection from '../../../components/landingPage/AcceleratorsPage/AccFlowsSection';
import AccProgrammePricingSection from '../../../components/landingPage/AcceleratorsPage/AccProgrammePricingSection';
import AccCohortHeroSection from '../../../components/landingPage/AcceleratorsPage/AccCohortHeroSection';
import AccCohortModulesSection from '../../../components/landingPage/AcceleratorsPage/AccCohortModulesSection';
import AccCohortPricingSection from '../../../components/landingPage/AcceleratorsPage/AccCohortPricingSection';
import AccCtaSection from '../../../components/landingPage/AcceleratorsPage/AccCtaSection';
// The Deal Management Platform tab reuses the exact sandbox and ecosystem sections the VC page
// renders — same component, not a copy, so the sandbox only ever exists in one place.
import SandboxSection from '../../../components/landingPage/common/SandboxSection';
import EcosystemSection from '../../../components/landingPage/common/EcosystemSection';
import { useReveal } from '../../../components/landingPage/common/landingHooks';
import AeoResourcesSection from '../../../components/landingPage/AeoArticles/AeoResourcesSection';
import useDocumentHead from '../../../components/landingPage/AeoArticles/useDocumentHead';
import hubWebPageSchema from '../../../components/landingPage/AeoArticles/aeoHubSchema';

const TABS = [
    { id: 'platform', label: 'Deal Management Platform' },
    { id: 'firm', label: 'Your Firm' },
    { id: 'cohort', label: 'Cohort Companies' },
];

// Accelerators & Venture Studios. Also the ICP hub page anchoring the /accelerator/* AEO article
// cluster — the canonical path, schema and resources list below are what make it that hub, so they
// must stay even though the marketing design does not show them.
const LandingHomeAccelerator = () => {
    const rootRef = useRef(null);
    // 'Your Firm' is the design's default landing tab, not the first one in the bar.
    const [tab, setTab] = useState('firm');
    // Passing the tab re-runs the reveal observer over the newly mounted panel.
    useReveal(rootRef, tab);
    useDocumentHead({
        title: 'Diligentsia for Accelerators — Investment-Ready Cohorts',
        description: 'Diligentsia helps accelerators get every cohort company investment-ready: certified Diligence Packs, AI-assisted document analysis, and consistent cohort reporting.',
        canonicalPath: '/accelerator/',
        schema: hubWebPageSchema('accelerator'),
    });

    const goToCohort = () => { setTab('cohort'); window.scrollTo({ top: 0, behavior: 'smooth' }); };

    return (
        <div className="lp-page lp-acc-page" ref={rootRef}>
            <AccHeroSection />
            <AccTabBar tabs={TABS} active={tab} onChange={setTab} />

            {tab === 'platform' && (
                <>
                    <SandboxSection />
                    <EcosystemSection />
                </>
            )}

            {tab === 'firm' && (
                <>
                    <AccMarketContextSection />
                    <AccReverseDiligenceSection />
                    <AccOnePlatformSection onSeeCohort={goToCohort} />
                    <AccOperatorModulesSection />
                    <AccFirstMoversSection />
                    <AccFlowsSection />
                    <AccProgrammePricingSection />
                </>
            )}

            {tab === 'cohort' && (
                <>
                    <AccCohortHeroSection />
                    <AccCohortModulesSection />
                    <AccCohortPricingSection />
                </>
            )}

            <AccCtaSection />
            <AeoResourcesSection icpSlug="accelerator" heading="Accelerator resources" />
        </div>
    );
};

export default LandingHomeAccelerator;
